export enum ValidationResultCode {
    VIN_TRANSFER_TO_OTHER_ARE = 'VIN_TRANSFER_TO_OTHER_ARE',
    VIN_TRANSFER_FROM_OTHER_ARE = 'VIN_TRANSFER_FROM_OTHER_ARE',
    VIN_ACTIVE_IN_OTHER_ARE = 'VIN_ACTIVE_IN_OTHER_ARE',
    VIN_EXISTS_IN_OTHER_ARE = 'VIN_EXISTS_IN_OTHER_ARE',
    VIN_TRANSFER_END_DATE_CONFLICT = 'VIN_TRANSFER_END_DATE_CONFLICT',
    VIN_AUTO_TERMINATED = 'VIN_AUTO_TERMINATED'
}
